import { createClient, type Session } from "@supabase/supabase-js";

const configuredSupabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const configuredSupabaseKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

export const isAuthConfigured = Boolean(
  configuredSupabaseUrl && configuredSupabaseKey,
);
export const supabase = createClient(
  configuredSupabaseUrl || "https://idffendosulnvqsaspio.supabase.co",
  configuredSupabaseKey || "local-development-key",
);

const apiUrl = (
  import.meta.env.VITE_API_URL ?? "http://127.0.0.1:8787"
).replace(/\/$/, "");
const testUser = "00000000-0000-4000-8000-000000000001";

export class AdminApiError extends Error {
  constructor(
    public code: string,
    message: string,
  ) {
    super(message);
  }
}

export async function adminApi<T>(
  path: string,
  session: Session | null,
  options: RequestInit = {},
) {
  const headers = new Headers(options.headers);
  headers.set("content-type", "application/json");
  if (session?.access_token)
    headers.set("authorization", `Bearer ${session.access_token}`);
  else if (import.meta.env.VITE_ENABLE_TEST_AUTH === "true")
    headers.set("x-vybra-test-user", testUser);
  const response = await fetch(`${apiUrl}${path}`, { ...options, headers });
  const payload = (await response.json()) as {
    data?: T;
    error?: { code: string; message: string };
  };
  if (!response.ok || payload.error)
    throw new AdminApiError(
      payload.error?.code ?? "INTERNAL_ERROR",
      payload.error?.message ?? "Request failed.",
    );
  return payload.data as T;
}

export function confirmOptions(body?: unknown): RequestInit {
  return {
    method: "POST",
    headers: { "x-admin-confirmation": "confirm" },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  };
}

export function adminSessionUserId(session: Pick<Session, "user"> | null) {
  return session?.user.id ?? null;
}

export function shouldClearAdminCache(
  currentUserId: string | null,
  nextSession: Pick<Session, "user"> | null,
) {
  return currentUserId !== adminSessionUserId(nextSession);
}
